import { render, staticRenderFns } from "./ShowSelection.vue?vue&type=template&id=1e754a65&scoped=true"
import script from "./ShowSelection.vue?vue&type=script&lang=js"
export * from "./ShowSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e754a65",
  null
  
)

export default component.exports